import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from '../data.service';
import { MeetingDto, LanguageCode } from '../shared/model';

@Injectable()
export class MainViewService {

  constructor(private dataService: DataService) { }

  getCategoryInfo(categoryId: number): Observable<any> {
    return this.dataService.get('Category/Info', { categoryId: categoryId });
  }

  getCategories(): Observable<any> {
    return this.dataService.get('Category/GetCategories', {});
  }

  getAdminCategories(): Observable<any> {
    return this.dataService.get('Category/GetAdminCategories', {});
  }

  getKeywords(languageCode: LanguageCode ): Observable<any> {
    return this.dataService.get('Keyword/GetKeywords', { languageCode: languageCode });
  }

  getLanguages(): Observable<any> {
    return this.dataService.get('Languages/GetLanguages', {});
  }

  getEnglishLanguage(): Observable<any> {
    return this.dataService.get('Languages/GetEnglish', {});
  }

  getAvailabilitySlots(categoryId: string, languageId: string ): Observable<any> {
    return this.dataService.get('Availability/GetAvailabilitiesSlotsByCategoryAndLanguage',
      { categoryId: categoryId, languageId:  languageId});
  }

  createMeeting(meeting: MeetingDto): Observable<any> {
      return this.dataService.post('Meeting/AddMeeting',  meeting);
  }
}
